<template>
    <footer class="footer px-4 py-6">
        <p class="text-sm text-gray-600 text-center">
            <a href="https://www.dkilo.com/" target="_blank">© {{ year }} dKilo, Inc.</a>
        </p>
    </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>